<template>
    <div class="block-partners__main">
        <h2 class="block-partners__title">{{ $t('homepartners.title') }}</h2>
        <div class="block-partners__list">
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.uwe.be" target="_blank">
                  <img src="@/assets/images/logos/logo_uwe.jpg" alt="UWE" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.agoria.be" target="_blank">
                  <img src="@/assets/images/logos/logo_agoria.jpg" alt="Agoria" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.wallonie-entreprendre.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_wallonie_entreprendre.png" alt="Wallonie entreprendre" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.awex.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_awex.png" alt="AWEX" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.bep.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_bep.png" alt="BEP" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.capinnove.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_cap_innove.png" alt="Cap Innove" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.ccilvn.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_cci_lvn.png" alt="CCI LVN" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.facebook.com/CEEILouvain/" target="_blank">
                  <img src="@/assets/images/logos/logo_cei_louvain.png" alt="CEI Louvain" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://charleroi-entreprendre.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_charleroi_entreprendre.png" alt="Charleroi Entreprendre" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://eklo.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_eklo.png" alt="EKLO" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://wallonie.embuild.be/fr" target="_blank">
                  <img src="@/assets/images/logos/logo_embuild.png" alt="Embuild" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.entreprendrewapi.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_entreprendre_wapi.png" alt="Entreprendre Wapi" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.greenwin.be/fr/" target="_blank">
                  <img src="@/assets/images/logos/logo_greenwin.png" alt="Greenwin" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.digitallab.be/fr/" target="_blank">
                  <img src="@/assets/images/logos/logo_hec_digital_lab.png" alt="HEC Digital Lab" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.idea.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_idea.png" alt="IDEA" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.idelux.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_idelux.png" alt="Idelux" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://clusters.wallonie.be/infopole/fr" target="_blank">
                  <img src="@/assets/images/logos/logo_infopole.png" alt="Infopole" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.lme.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_la_maison_de_l_entreprise.png" alt="La Maison de l'Entreprise" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.mic-belgique.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_mic.png" alt="MIC" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.ucm.be/" target="_blank">
                  <img src="@/assets/images/logos/logo_ucm.png" alt="UCM" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.wfg.be/fr/home-2/" target="_blank">
                  <img src="@/assets/images/logos/logo_wfg_ostbelgien.png" alt="WFG Ostbelgien" />
                </a>
              </div>
            </div>
            <div class="block-partners__list-item">
              <div class="partner-logo">
                <a href="https://www.wallonie.be/fr/acteurs-et-institutions/wallonie/service-public-de-wallonie/spw-economie-emploi-recherche" target="_blank">
                  <img src="@/assets/images/logos/logo_spw_eer.png" alt="SPW EER" />
                </a>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BlockLogoPartner',
};
</script>

<style scoped>
.block-partners__list {
  flex-wrap: wrap;
  justify-content: space-between;
}
.block-partners__list-item {
  flex: auto;
  width: 12%;
  padding: 1em;
}
@media (max-width: 46.24em) {
  .block-partners__list-item {
    width: 50%;
  }
}
.partner-logo img {
  max-height: 8em;
}
</style>
